import * as moment from "moment";

import * as actions from "./actiontypes";
import { OhCaseAction } from "./actions";
import { OhCase, TaskModel } from "./model";

export function ohCases(state: OhCase[] = [], action: OhCaseAction): OhCase[] {
    switch (action.type) {
        case actions.LOAD_OHCASES_SUCCESS:
            return action.payload.map(c => ({ ...(state.find(s => s.id === c.id) || {}), ...c, listUpdated: moment() }));
        case actions.SAVE_OHCASE_SUCCESS:
        case actions.LOAD_OHCASE_DETAIL_SUCCESS:
        case actions.CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS_SUCCESS:
        case actions.LOAD_LINE_MANAGERS_SUCCESS:
        case actions.LOAD_HR_REPRESENTATIVES_SUCCESS:
        case actions.UPDATE_ADDITIONAL_MANAGERS_SUCCESS:
            if (!state.some(c => c.id === (action.payload.id))) {
                return [ ...state, ohCase(action.payload, action) ];
            }
            return state.map(c => ohCase(c, action));
        case actions.LOAD_OHCASE_APPOINTMENTS_SUCCESS:
            if (!state.some(c => c.id === action.payload.ohCaseId)) {
                const newOhCase = {
                    id: action.payload.ohCaseId,
                    appointments: action.payload.appointments
                };
                return [ ...state, newOhCase ];
            }
            return state.map(c => ohCase(c, action));
        case actions.CREATE_OHCASE_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.DELETE_OHCASE_SUCCESS:
            return [...state.filter(c => c.id !== action.payload)];
        case actions.LOAD_OHCASE_DOCUMENTS_SUCCESS:
            return state.map(c => ohCase(c, action));
        default:
            return state;
    }
}

function ohCase(state: OhCase, action: OhCaseAction): OhCase {
    switch (action.type) {
        case actions.SAVE_OHCASE_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_OHCASE_DETAIL_SUCCESS:
            if (action.payload.id === state.id) {
                return detailUpdated(action.payload, state);
            }
            return state;
        case actions.LOAD_OHCASE_DOCUMENTS_SUCCESS:
            if (action.payload.ohCaseId === state.id) {
                return { ...state, documents: action.payload.documents };
            }
            return state;
        case actions.LOAD_OHCASE_APPOINTMENTS_SUCCESS:
            if (action.payload.ohCaseId === state.id) {
                return { ...state, appointments: action.payload.appointments };
            }
            return state;
        case actions.CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS_SUCCESS:
            if (action.payload.id === state.id) {
                return {
                    ...state,
                    secondaryCaseStatus: action.payload.secondaryCaseStatus,
                    secondaryCaseStatusChangesNotes: action.payload.secondaryCaseStatusChangesNotes,
                    tasks: [...action.payload.tasks.map(parseTaskModel)]
                };
            }
            return state;
        case actions.LOAD_LINE_MANAGERS_SUCCESS:
            if (action.payload.id === state.id) {
                return { ...state, lineManagers: action.payload.lineManagers };
            }
            return state;
        case actions.LOAD_HR_REPRESENTATIVES_SUCCESS:
            if (action.payload.id === state.id) {
                return { ...state, hrRepresentatives: action.payload.hrRepresentatives };
            }
            return state;
        case actions.UPDATE_ADDITIONAL_MANAGERS_SUCCESS:
            if (action.payload.id === state.id) {
                return {
                    listUpdated: moment(),
                    ...state,
                    associatedManagerIds: action.payload.associatedManagers.map(m => m.id),
                    associatedHrIds: action.payload.associatedHrUsers.map(h => h.id),
                    detailUpdated: moment()
                };
            }
            return state;
        default:
            return state;
    }
}

function detailUpdated(value: OhCase, state: OhCase = {} as OhCase): OhCase {
    return { listUpdated: moment(), ...state, ...value, detailUpdated: moment() };
}

function parseTaskModel(task: TaskModel) {
    return {
        ...task,
        dueDate: task.dueDate && moment(task.dueDate),
        dateCreated: task.dateCreated && moment(task.dateCreated),
        completedDate: task.completedDate && moment(task.completedDate)
    };
}
